import React from "react";
// Router
import { Link } from "react-router-dom";
// Componentes
import ComponentTable from "../../generic/ComponentsTable";
// Utils
import { dateToString } from "../../../utils";
// Contexto
import { cargosServiciosComunitarios, cargosServiciosProvinciales, cargosDireccionGeneral, cargosEquiposComisiones, cargosEquiposDirectivos } from "../../../contexto";

const TablaVidaReligiosa = ({ vidaReligiosa }) => {
  // Procesa la fecha startdate y la devuelve
  const processStartDate = (row) => {
    if (row.startDate) return dateToString(row.startDate);
    else return "";
  };

  // Procesa la fecha de endDate y la devuelve
  const processEndDate = (row) => {
    if (row.endDate) return dateToString(row.endDate);
    else return "No especificado";
  };

  // Procesa la informción de donde viene el cargo
  const processDonde = (row) => {
    switch (row.cargoTableType) {
      case "province":
        if (row.cargoTableId === '14') {
          return <Link to={`/direccionGeneral`}>{`Dirección General`}</Link>;
        } else return <Link to={`/provincias/${row.cargoTableId}`}>{row.provincia.name}</Link>;
      case "RepresentanteLegal":
        return <Link to={`/provincias/${row.cargoTableId}`}>{row.provincia.name}</Link>;
      case "workgroup":
        return row.workgroup?.name;
      case "community":
        return row.comunidad.name;
      case "mission":
        return row.mission.name;
      default:
        return "";
    }
  };

  // Procesa el
  const processCargo = (row) => {
    switch (row.cargoTableType) {
      case "province":
        if (row.cargoTableId === '14') {
          return cargosDireccionGeneral[row.cargo];
        } else return cargosServiciosProvinciales[row.cargo];
      case "workgroup":
        return cargosEquiposComisiones[row.cargo];
      case "community":
        return cargosServiciosComunitarios[row.cargo];
      case "mission":
        return cargosEquiposDirectivos[row.cargo];
      default:
        return "";
    }
  };
  return (
    <ComponentTable
      emptyTableComponent={<p className="m-2">{`No se han encontrado servicios`}</p>}
      headers={[
        { name: "Servicio", value: processCargo },
        { name: "Donde", value: processDonde },
        { name: "Fecha inicio", value: processStartDate },
        { name: "Fecha de fin", value: processEndDate },
      ]}
      rows={vidaReligiosa}
    />
  );
};

export default TablaVidaReligiosa;
